import Lenis from 'lenis';

const ready = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
};

function initLenis() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return null;
  }

  if (window.lenis && typeof window.lenis.destroy === 'function') {
    return window.lenis;
  }

  const lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
  });

  window.lenis = lenis;

  if (typeof window.ScrollTrigger !== 'undefined') {
    lenis.on('scroll', window.ScrollTrigger.update);
  }

  if (typeof window.gsap !== 'undefined') {
    window.gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    window.gsap.ticker.lagSmoothing(0);
  } else {
    function raf(time) {
      lenis.raf(time);
      window.requestAnimationFrame(raf);
    }

    window.requestAnimationFrame(raf);
  }

  return lenis;
}

ready(() => {
  initLenis();
});
